var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7.49a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79zM8 11v6h2v-6z"
})));
export { SvgHome as ReactComponent };
export default __webpack_public_path__ + "e0c876fbaea9e603e9b66c877441a092.svg";